import React, { useRef, useState } from 'react';
import { Lock } from 'lucide-react';
import { usePremium } from '../Subscription/PremiumProvider';
import TabButton from '../common/TabButton';
import PremiumUpgradeModal from '../Subscription/PremiumUpgradeModal';
// Update the isPremiumFilter helper function to include No Mastery
const isPremiumFilter = (filter) => {
  const premiumFilters = [
    'No Mastery (0%)',
    'Low Mastery (<50%)',
    'High Mastery (>50%)',
    'Full Mastery (100%)'
  ];
  return premiumFilters.includes(filter);
};

const ScrollableFilter = ({ items, activeItem, onItemClick, getCount, renderItem, searchInputRef }) => {
  const { isPremium } = usePremium();
  const containerRef = useRef(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  return (
    <>
      <div className="mb-6">
        <div className="relative">
          {/* Add fade effect on edges */}
          <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-neutral-50 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-neutral-50 to-transparent z-10" />
          
          {/* Scrollable container */}
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex gap-2 p-2 min-w-min whitespace-nowrap px-8">
              {items.map((item) => {
                const isPremiumMasteryFilter = isPremiumFilter(item);
                const showPremiumOverlay = isPremiumMasteryFilter && !isPremium();

                return (
                  <div key={typeof item === 'string' ? item : item.id} className="relative group">
                    <TabButton
                      active={activeItem === (typeof item === 'string' ? item : item.name)}
                      onClick={() => {
                        if (!showPremiumOverlay) {
                          onItemClick(item);
                          if (searchInputRef?.current) {
                            searchInputRef.current.focus();
                          }
                        }
                      }}
                      count={getCount(item)}
                      className={`${typeof item !== 'string' ? 'tag-filter-button' : ''} 
                                ${showPremiumOverlay ? 'blur-[1px]' : ''}`}
                      disabled={showPremiumOverlay}
                    >
                      {renderItem(item)}
                    </TabButton>

                    {/* Premium Overlay - Now opens modal */}
                    {showPremiumOverlay && (
                      <div 
                        onClick={() => setShowUpgradeModal(true)}
                        className="absolute inset-0 bg-white/60 backdrop-blur-[1px] rounded-lg 
                                  opacity-0 group-hover:opacity-100 transition-opacity
                                  flex items-center justify-center cursor-pointer
                                  hover:bg-white/70"
                      >
                        <div className="flex items-center gap-1.5 px-2 py-1 bg-white/80 rounded-md border-2 border-blue-200">
                          <Lock className="w-3.5 h-3.5 text-blue-500" />
                          <span className="text-xs font-medium text-blue-600">
                            Premium
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Premium Upgrade Modal */}
      <PremiumUpgradeModal 
        isOpen={showUpgradeModal} 
        onClose={() => setShowUpgradeModal(false)} 
      />
    </>
  );
};

export default ScrollableFilter; 